import { render, staticRenderFns } from "./ProfessionalExpenses.vue?vue&type=template&id=639d3e6e"
import script from "./ProfessionalExpenses.vue?vue&type=script&lang=js"
export * from "./ProfessionalExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports